import type { ToastContainerProps } from 'react-toastify';

export const classes = {
  app: 'relative min-h-dvh w-full bg-mesh dark:bg-mesh-dark',
  content: 'relative z-10 backdrop-blur-[34px] bg-frame dark:bg-frame-dark',
  notFound: 'place-center min-h-dvh text-2xl text-taupe-2 dark:text-mauve-2',
};

export const toastContainerProps: ToastContainerProps = {
  hideProgressBar: true,
  closeOnClick: true,
  newestOnTop: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  rtl: false,
  draggable: false,
  theme: 'light',
  position: 'bottom-right',
  autoClose: 3000,
  toastStyle: {
    borderRadius: '1rem',
    padding: '0.6rem',
    paddingRight: '0.8rem',
  },
};
